import * as mat from "../components/materials"
import { gsap } from 'gsap'


// ------------------------------------------------------------

export const LOCAL_ = window.location.host == 'localhost:3030' ? true : false

//

export async function realLoader(clock, callback, target) {

    const loadControl = window.loadControl

    let loaded = 0
    let total = 0
    Object.keys(loadControl.elements).forEach( (key) => {
        loaded += loadControl.elements[key].loaded
        total += loadControl.elements[key].total
    })
    if (target == '_estadio') total = 9797313 // v32 10062657 // v31 9969693 // v30 9871229 // v29 10179593

    loadControl.values = { loaded, total }
    loadControl.textures = mat.texturesData 

    //

    let elements = Math.round( (loaded / total) * 100)
    if( isNaN(elements) || total < 1024) elements = 0
    // loadControl.value = (mat.texturesData.size.percent + elements) / 2
    loadControl.value = elements

    if(document.querySelector('.loader-value')) document.querySelector('.loader-value').innerHTML = `${loadControl.value.toFixed(0)}%`

    if(loadControl.value === 100 && mat.texturesData.managerState === 'Ready') {

        // console.log(total)

        if(LOCAL_) console.log(`Ready at ${(clock.getElapsedTime()).toFixed(2)}s \n  Textures: ${mat.texturesData.total} | Total: ${( (total) /1024/1024).toFixed(2)}Mb`)
        loadControl.finish = true

        await callback()

        gsap.to('.loader', {
            opacity: 0, scale: 1.25,
            duration: 1, delay: 0.25, ease: 'power1.in',
            onComplete() { this.targets()[0] && this.targets()[0].remove() }
        })

        if(target && target !== '_estadio') {
            gsap.to( `#canvas-${target}`, {
                opacity: 1, 
                duration: 1, delay: 0.25, ease: 'power1.in',
            })
        }
    }
}

export async function internalLoader(loadControl, target, callback) {

    let loaded = 0
    let total = 0
    Object.keys(loadControl.elements).forEach( (key) => {
        loaded += loadControl.elements[key].loaded
        total += loadControl.elements[key].total
    })

    //
    let elements = Math.round( (loaded / total) * 100)
    if( isNaN(elements) || total < 1024) elements = 0
    loadControl.value = elements

    document.querySelector( `.loader-${target} .loader-value` ).innerHTML = `${loadControl.value.toFixed(0)}%`

    //
    if(loadControl.value === 100) {

        loadControl.finish = true
        await callback()

        const t = gsap.timeline()

        t.to(`.loader-${target}`, {
            opacity: 0, scale: 1.25,
            duration: 1.5, delay: 0.5, ease: 'power1.out',
            onComplete() { this.targets()[0].remove() }
        })
        t.to( `#canvas-${target}`, {
            opacity: 1, 
            duration: 1, ease: 'power1.in',
        }, '-=0.5')
    }
}


//
export const isM = (function isMobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
}())
export function getRealSize(HTMLelement) {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
        //
    let containerStyle = window.getComputedStyle(HTMLelement)
    const w = parseInt( containerStyle.width.slice(0, -2) )
    const h = parseInt( containerStyle.height.slice(0, -2) )

    return { w, h }
}

//

export const inRange = (x, min, max) => { return x >= min && x <= max }
export const degToRad = (deg) => { return deg * Math.PI / 180 }
export const lerp = (start, end, amt) => { return (1-amt)*start+amt*end }
export const randomNum = (min, max, last) => {
    const v = Math.floor( Math.random() * (max - min) + min )

    if (last) {
        return v == last ? randomNum(min, max, last) : v
    } else {
        return v
    }
    
}
export const toTitleCase = (str) => {
    return str.replace(
      /\w\S*/g,
      function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }

//

export function crossfadeAction( currentAction, nextAction, duration) {

    // Unpause both actions
    // if(currentAction) currentAction.paused = false
    nextAction.paused = false

    // Set weight
    nextAction.enabled = true
    nextAction.setEffectiveTimeScale( 1 )
    nextAction.setEffectiveWeight( 1 )
    nextAction.time = 0

    // Execute cross fade
    if(currentAction) currentAction.fadeOut(duration)
    nextAction.reset().fadeIn(duration).play()
    
}